import React from 'react';
import { DataVizContainer } from '../common/DataVizContainer';
import {
  KpiFactboxTwoMetricVizConfig,
  KpiFactboxTwoMetricVizExternalProps,
  KpiFactboxTwoMetricVizViews,
} from './types';
import { useKpiFactboxTwoMetricConfigToData } from './useConfigToData';
import { twoMetricKpiFactboxViewConfigs } from './views/view-configs';

export interface KpiFactboxTwoMetricVizProps {
  dataConfig: KpiFactboxTwoMetricVizConfig;
  selectedView: KpiFactboxTwoMetricVizViews;
  externalProps: KpiFactboxTwoMetricVizExternalProps;
  persistenceKey: string;
}

export const KpiFactboxTwoMetricViz = (props: KpiFactboxTwoMetricVizProps) => {
  return (
    <DataVizContainer
      dataConfig={props.dataConfig}
      externalProps={props.externalProps}
      useConfigToData={useKpiFactboxTwoMetricConfigToData}
      selectedView={props.selectedView}
      viewConfigs={twoMetricKpiFactboxViewConfigs}
      persistenceKey={props.persistenceKey}
    />
  );
};
